import { render } from "./DisclousersView.vue?vue&type=template&id=0de35c09"
import script from "./DisclousersView.vue?vue&type=script&lang=js"
export * from "./DisclousersView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__